<template>
  <div :class="{ 'primary-input': true, invalid: invalid }">
    <textarea
      :value="modelValue"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      :rows="rows"
      @input="updateValue"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      :class="{ readonly: readonly }"></textarea>
    <label>{{ label }}</label>
    <label v-if="required && invalid" class="required">Required Field</label>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 4,
    },
  },
  emits: ['update:modelValue', 'blur', 'focus'],
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
// Styles are handled by the global inputs.scss file
</style>
